import { z } from 'zod';

// Param schemas
export const orgTagIdParam = z.object({
  id: z.string().uuid(),
});

// Query schemas
export const listOrgTagsQuery = z.object({
  organization_id: z.string().uuid(),
});

// Body schemas
export const createOrgTagBody = z.object({
  organization_id: z.string().uuid(),
  name: z.string().min(1).max(50).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, {
    message: 'Must be lowercase alphanumeric with hyphens (e.g. "my-tag")',
  }),
  display_name: z.string().max(100).nullish(),
  color: z.string().max(20).nullish(),
});

export const updateOrgTagBody = z.object({
  // Required so the route targets the org the UI is managing (which may differ
  // from the token's default `auth.org_id` for multi-org users) — mirrors create/list.
  organization_id: z.string().uuid(),
  name: z.string().min(1).max(50).regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, {
    message: 'Must be lowercase alphanumeric with hyphens (e.g. "my-tag")',
  }).optional(),
  display_name: z.string().max(100).nullish(),
  color: z.string().max(20).nullish(),
});

// Inferred types
export type CreateOrgTagInput = z.infer<typeof createOrgTagBody>;
export type UpdateOrgTagInput = z.infer<typeof updateOrgTagBody>;

// =============================================================================
// RESPONSE TYPES
// =============================================================================

export interface OrgTagResponse {
  tag_id: string;
  name: string;
  display_name: string | null;
  color: string | null;
  created_at: string;
  updated_at: string;
}

export interface ListOrgTagsResponse {
  data: OrgTagResponse[];
}

export interface CreateOrgTagResponse {
  data: OrgTagResponse;
}

export interface UpdateOrgTagResponse {
  data: OrgTagResponse;
}
